import DiscountEditModal from './DiscountEditModal'

export default DiscountEditModal